if (!customElements.get('promo-offer')) {
  class PromoOffer extends HTMLElement {
    connectedCallback() {
      this.codeElement = this.querySelector('[data-code]');
      this.copyButton = this.querySelector('[data-copy]');
      this.status = this.querySelector('[data-copy-status]');
      if (!this.codeElement || !this.copyButton) return;
      this.onCopy = () => this.copyCode();
      this.copyButton.addEventListener('click', this.onCopy);
      this.codeElement.addEventListener('click', this.onCopy);
    }

    disconnectedCallback() {
      clearTimeout(this.resetTimer);
      if (!this.onCopy) return;
      this.copyButton.removeEventListener('click', this.onCopy);
      this.codeElement.removeEventListener('click', this.onCopy);
    }

    async copyCode() {
      const code = this.codeElement.textContent.trim();
      try {
        await navigator.clipboard.writeText(code);
        this.showCopied();
      } catch {
        this.selectCode();
      }
    }

    showCopied() {
      clearTimeout(this.resetTimer);
      this.classList.add('is-copied');
      this.announce(this.dataset.copiedLabel);
      this.resetTimer = setTimeout(() => {
        this.classList.remove('is-copied');
        this.announce('');
      }, 2000);
    }

    selectCode() {
      const range = document.createRange();
      range.selectNodeContents(this.codeElement);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      this.announce(this.dataset.copyFail);
    }

    announce(message) {
      if (this.status) this.status.textContent = message || '';
    }
  }

  customElements.define('promo-offer', PromoOffer);
}
